import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  AddBuyersToListInput,
  AddBuyersToListMutation,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const addBuyersToListMutation = graphql(`
  mutation addBuyersToList($input: AddBuyersToListInput!) {
    addBuyersToList(input: $input) {
      id
      name
    }
  }
`);

export function useAddBuyerEntries(
  options?: UseMutationOptions<AddBuyersToListMutation, unknown, AddBuyersToListInput, unknown>,
) {
  const queryClient = useQueryClient();
  const { mutate: innerMutate, ...rest } = useGraphQlMutation(addBuyersToListMutation, {
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["buyerLists"]);
      void queryClient.invalidateQueries(["buyerList", variables.input.id]);
      void queryClient.invalidateQueries(["searchOrganisationsViaOs"]);
      void queryClient.invalidateQueries(["supplierStatsOrganisation"]);
      void queryClient.invalidateQueries(["buyers", "buyersForSupplier"]);
      options?.onSuccess?.(data, variables.input, context);
    },
    onError: (error, variables, context) => options?.onError?.(error, variables.input, context),
  });
  return { ...rest, mutate: (input: AddBuyersToListInput) => innerMutate({ input }) };
}
